import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ManualTotal_Update_Mutation = graphql(`
  mutation ResolvableMissionTypeForm_ManualTotal_Update(
    $manualTotal: ResolvableServiceValueInput!
    $serviceUsagesGroupId: Id!
    $serviceUserId: Id!
    $versionData: VersionDataInput
  ) {
    updateResolvableMissionTypeManualTotal(
      manualTotal: $manualTotal
      serviceUsagesGroupId: $serviceUsagesGroupId
      serviceUserId: $serviceUserId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateResolvableMissionTypeManualTotalMutation = () =>
  useGraphQLMutation(ResolvableMissionTypeForm_ManualTotal_Update_Mutation);
